<template>
  <div class="bigscreen">
    <button class="bigscreen-back" type="button" @click="goBackHome">
      <i class="el-icon-arrow-left"></i>
      <span>返回首页</span>
    </button>

    <el-row :gutter="16" class="full">
      <el-col :span="24" class="left">
        <el-row>
          <el-card class="toolbar" shadow="never">
            <el-form :model="filters" inline label-width="80px" size="small">
              <el-form-item label="时间范围">
                <el-date-picker v-model="filters.range" type="datetimerange" start-placeholder="开始时间"
                  end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
                  align="right" @change="onRangeChange" />
              </el-form-item>
              <el-form-item label="房间">
                <el-select v-model="filters.room" placeholder="全部房间" filterable clearable>
                  <el-option v-for="room in rooms" :key="room.value" :label="room.label" :value="room.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="来源">
                <el-select v-model="filters.source" placeholder="全部来源" filterable clearable>
                  <el-option v-for="src in sources" :key="src.value" :label="src.label" :value="src.value" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button @click="handleReset">重置</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-row>


        <el-alert v-if="error" type="warning" :closable="false" class="error-alert">
          {{ error }}
        </el-alert>

        <div v-loading.fullscreen.lock="loading" style="position:relative;"
          element-loading-background="rgba(5,11,26,0.85)" element-loading-custom-class="my-loading"
          element-loading-text="加载中...">
          <el-row :gutter="30">
            <el-col :span="6">
              <el-card class="panel watch-card" shadow="always">
                <div slot="header" class="panel-title">观看</div>
                <div class="watch-items">
                  <div class="watch-item">
                    <span class="watch-label">观看达 3 秒的次数</span>
                    <span class="watch-value">{{ formatNumber(watchMetrics.watch3s) }}</span>
                  </div>
                  <div class="watch-item">
                    <span class="watch-label">观看达 15 秒的次数</span>
                    <span class="watch-value">{{ formatNumber(watchMetrics.watch15s) }}</span>
                  </div>
                  <div class="watch-item">
                    <span class="watch-label">观看达 60 秒的次数</span>
                    <span class="watch-value">{{ formatNumber(watchMetrics.watch60s) }}</span>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="18">
              <el-row :gutter="12" class="kpi-row">
                <el-col v-for="item in kpis" :key="item.key" :span="6">
                  <el-card class="panel kpi-card" shadow="hover">
                    <template v-if="item.key === 'qualityRates'">
                      <div class="kpi-dual-metrics">
                        <div class="kpi-dual-row">
                          <span>音频加载成功率</span>
                          <strong>{{ formatPercent(successRates.audio) }}</strong>
                        </div>
                        <div class="kpi-dual-row">
                          <span>弹幕成功率</span>
                          <strong>{{ formatPercent(successRates.danmaku) }}</strong>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="kpi-label">{{ item.label }}</div>
                      <div class="kpi-value">
                        {{ item.key == 'danmuTotal' ? danmuTotal : item.value }}
                      </div>
                      <div class="kpi-delta" :class="{ up: item.delta >= 0, down: item.delta < 0 }">
                        <span v-if="item.delta >= 0">▲</span>
                        <span v-else>▼</span>
                        {{ formatDelta(item.delta) }}%
                      </div>
                    </template>
                  </el-card>
                </el-col>
              </el-row>
            </el-col>

          </el-row>




          <el-row :gutter="20">
            <el-col :span="8">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-header">
                  <div class="panel-title">RTC Join 耗时趋势（声网进房）</div>
                  <div class="panel-substats">
                    <span>Avg / P95</span>
                  </div>
                </div>
                <EChartsBox :option="rtcJoinOption" height="280px" />
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-header">
                  <div class="panel-title">实时观看趋势</div>
                  <div class="panel-substats">
                    <span>播放成功率 <strong>{{ formatPercent(successRates.playback) }}</strong></span>
                    <span>弹幕成功率 <strong>{{ formatPercent(successRates.danmaku) }}</strong></span>
                  </div>
                </div>
                <EChartsBox :option="lineOption" height="280px" />
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-header">
                  <div class="panel-title">播放成功率（维度组合）</div>
                  <div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">
                    <el-select v-model="successDim" size="mini" style="width:130px">
                      <el-option label="按地区查看" value="region" />
                      <el-option label="按平台查看" value="platform" />
                    </el-select>
                    <el-select v-model="filterRegion" size="mini" multiple collapse-tags clearable placeholder="地区筛选"
                      style="width:100px">
                      <el-option v-for="opt in filterOptions.region" :key="opt" :label="opt" :value="opt" />
                    </el-select>
                    <el-select v-model="filterPlatform" size="mini" multiple collapse-tags clearable placeholder="平台筛选"
                      style="width:130px">
                      <el-option v-for="opt in platformOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                    </el-select>
                  </div>
                </div>
                <EChartsBox :option="playinfoOption" height="280px" />

              </el-card>
            </el-col>
          </el-row>

          <el-row :gutter="12" class="chart-grid">
            <el-col :span="12">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-title">IP 地区占比</div>
                <EChartsBox :option="regionOption" height="260px" />
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="panel chart-card" shadow="always">
                <div slot="header" class="panel-title">浏览器占比</div>
                <EChartsBox :option="browserOption" height="260px" />
              </el-card>
            </el-col>
          </el-row>

          <el-card class="panel table-card" shadow="always">
            <div slot="header" class="panel-title">3秒内无效 / 未知明细</div>
            <el-table :data="abnormalList" size="small" height="500" stripe empty-text="暂无异常记录">
              <el-table-column prop="timestamp" label="时间" min-width="130" />
              <el-table-column prop="ip" label="IP" min-width="120" />
              <el-table-column prop="region" label="地区" min-width="140" />
              <el-table-column prop="device" label="终端" min-width="120" />
              <el-table-column prop="reason" label="原因" min-width="180" show-overflow-tooltip />
            </el-table>
          </el-card>
        </div>

      </el-col>
    </el-row>
  </div>
</template>
<script>
import EChartsBox from '@/components/EChartsBox.vue'
import { liveroomsList, getAppid, getDanmu } from '@/api'
import {
  LIVE_STATS_PATHS,
  LEGACY_LIVE_STATS_PATHS,
  buildLiveStatsUrl,
  fetchLiveStatsJsonWithFallback,
} from '@/utils/live-stats-api'

const DEFAULT_STATS_BASE = process.env.NODE_ENV == 'production' ? 'https://anal.wokfoy.com' : 'https://anal.wokfoy.com'
const PLATFORM_DEFS = [
  { key: 'default', label: 'Default', aliases: ['default', 'direct'] },
  { key: 'app', label: 'App', aliases: ['app'] },
  { key: 'facebook', label: 'Facebook', aliases: ['fb', 'facebook'] },
  { key: 'tiktok', label: 'TikTok', aliases: ['tk', 'tiktok', 'ttq'] },
  { key: 'youtube', label: 'YouTube', aliases: ['yt', 'youtube'] },
  { key: 'pinterest', label: 'Pinterest', aliases: ['pin', 'pinterest'] },
  { key: 'instagram', label: 'Instagram', aliases: ['ins', 'instagram'] },
  { key: 'whatsapp', label: 'WhatsApp', aliases: ['wa', 'whatsapp'] },
  { key: 'messenger', label: 'Messenger', aliases: ['msg', 'messenger'] },
  { key: 'line', label: 'LINE', aliases: ['line'] },
  { key: 'telegram', label: 'Telegram', aliases: ['tg', 'telegram'] },
  { key: 'reddit', label: 'Reddit', aliases: ['rd', 'reddit'] },
  { key: 'snapchat', label: 'Snapchat', aliases: ['snap', 'snapchat'] },
  { key: 'shopify', label: 'Shopify', aliases: ['shopify'] },
  { key: 'shop', label: 'Shop', aliases: ['shop', 'ms_shop', '商城'] },
  { key: 'unknown', label: '未知平台', aliases: ['未知平台', 'unknown'] },
]
const PLATFORM_FILTERS = [
  ...PLATFORM_DEFS.map(item => ({ label: item.label, value: item.label })),
  { label: '其他', value: '其他' },
]
const PLATFORM_ALIAS_TO_LABEL = PLATFORM_DEFS.reduce((map, item) => {
  item.aliases.forEach(alias => {
    map[String(alias).toLowerCase()] = item.label
  })
  return map
}, {})

export default {
  name: 'BigScreen',
  components: { EChartsBox },
  data() {
    return {
      successDim: 'platform',
      filterRegion: [],
      filterPlatform: [],
      filterOptions: { region: [] },
      platformOptions: PLATFORM_FILTERS,
      visitsRaw: [],

      loading: false,
      error: '',
      apiBase: DEFAULT_STATS_BASE,
      filters: {
        range: [],
        room: '',
        source: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近1小时',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '今天',
            onClick: picker => {
              const end = new Date()
              const start = new Date(new Date().setHours(0, 0, 0, 0))
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 3 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 7 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近半个月',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 15 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 30 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 3 * 30 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近半年',
            onClick: picker => {
              const end = new Date()
              const start = new Date(end.getTime() - 6 * 30 * 24 * 60 * 60 * 1000)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      rooms: [{ label: '全部房间', value: '' }],
      sources: [
        { label: '全部来源', value: '' },
        { label: 'tiktok', value: 'tiktok' },
        { label: 'facebook', value: 'facebook' },
        { label: 'youtube', value: 'youtube' },
        { label: 'pinterest', value: 'pinterest' },
        { label: 'ins', value: 'instagram' },
        { label: 'X', value: 'X' },
        { label: 'snap', value: 'snap' },
      ],
      kpis: [
        { key: 'uv', label: 'UV', value: '0', delta: 0 },
        { key: 'pv', label: 'PV', value: '0', delta: 0 },
        { key: 'pullSuccessRate', label: '拉流成功率', value: '0%', delta: 0 },
        { key: 'avgPullSeconds', label: '平均拉流秒数', value: '0.0s', delta: 0 },
        { key: 'danmuTotal', label: '弹幕总数', value: 0, delta: 0 },
        { key: 'shoppingCartTotal', label: '购物车点击', value: 0, delta: 0 },
        { key: 'contactTotal', label: '联系客服点击', value: 0, delta: 0 },
        { key: 'qualityRates', label: '加载成功率', value: null, delta: 0 }
      ],
      danmuTotal: 0,
      roomIdByStreamName: {},
      danmuTotalRequestSeq: 0,
      watchMetrics: { watch3s: 0, watch15s: 0, watch60s: 0 },
      chartData: {
        watchTrend: { timestamps: [], values: [] },
        sourceBar: { categories: [], series: [] },
        devicePie: [],
        regionBar: { categories: [], series: [] },
        browserPie: []
      },
      lineOption: {},
      rtcJoinOption: {},
      barOption: {},
      deviceOption: {},
      regionOption: {},
      browserOption: {},
      abnormalList: [],
      successRates: { playback: 0, audio: 0, danmaku: 0 },
      rtcJoinLastFetchAt: 0,
      rtcJoinMinRefreshMs: 30000,
      // === SSE 实时更新（增量事件） ===
      sse: null,
      visitIndex: null,
      recomputeTimer: null,
      recomputeDelayMs: 500,
      isRealtime: true,
      wokfoy_appid:''
    }
  },
  async mounted() {
    let { data: apps } = await getAppid()
    this.wokfoy_appid = apps[0].id
    this.initFilters()
    await this.loadRooms()
    await this.loadDashboardData()
    this.startSSE()
  },
  beforeDestroy() {
    this.closeSSE()
  },
  computed: {
    // 组合筛选 + 维度分组 饼图
    playinfoOption() {
      return this.BuildPlayInfoOption(
        this.visitsRaw,
        this.successDim,
        {
          region: this.filterRegion,
          platform: this.filterPlatform,
        }
      )
    },
  },
  watch: {
    '$route.query.room'(next) {
      const normalized = String(next || '').trim()
      if (normalized && normalized !== this.filters.room) {
        this.filters.room = normalized
      }
    }
  },
  methods: {
    goBackHome() {
      this.$router.push('/')
    },
    // === 维度解析/过滤 ===
    bucketUSRegion(country, region) {
      const east = new Set(['ME', 'NH', 'VT', 'MA', 'RI', 'CT', 'NY', 'NJ', 'PA', 'DE', 'MD', 'DC', 'VA', 'NC', 'SC', 'GA', 'FL', 'WV']);
      const west = new Set(['WA', 'OR', 'CA', 'NV', 'ID', 'MT', 'WY', 'UT', 'AZ', 'AK', 'HI', 'CO', 'NM']);
      if ((country || '').toUpperCase() !== 'US') return '其他';
      const code = (region || '').toUpperCase();
      if (west.has(code)) return '美国西部';
      if (east.has(code)) return '美国东部';
      return '其他';
    },
    detectOS(v) {
      const ua = (v.ua || v.user_agent || '').toLowerCase();
      if (/iphone|ipad|ios/.test(ua)) return 'ios';
      if (/android/.test(ua)) return '安卓';
      if (/winfow/.test(ua)) return 'Window';
      return '其他';
    },
    detectPlatform(v) {
      const ref = String(v.referer || '').toLowerCase();
      const extra = v.extra_json || {};
      const candidates = [
        extra.utm_source,
        extra.source,
        extra.platform,
        extra.fromplat,
        v.platform,
        v.source,
      ].filter(value => value != null && value !== '');

      for (const candidate of candidates) {
        const label = this.normalizePlatformLabel(candidate)
        if (label) return label
      }

      const queryMatch = ref.match(/(?:[?&#]|^)(?:utm_source|source|platform|fromplat)=([^&#\s]+)/i)
      if (queryMatch) {
        const label = this.normalizePlatformLabel(queryMatch[1])
        if (label) return label
      }

      for (const item of PLATFORM_DEFS) {
        if (item.aliases.some(alias => {
          const key = String(alias).toLowerCase()
          return ref.includes(`utm_source=${key}`)
            || ref.includes(`source=${key}`)
            || ref.includes(`platform=${key}`)
            || ref.includes(`fromplat=${key}`)
            || ref.includes(`${key}_return`)
            || (key.length >= 4 && ref.includes(key))
        })) {
          return item.label
        }
      }
      return '其他';
    },
    normalizePlatformLabel(value) {
      const raw = String(value || '').trim()
      if (!raw) return ''
      let decoded = raw
      try {
        decoded = decodeURIComponent(raw.replace(/\+/g, ' '))
      } catch (e) {
        decoded = raw
      }
      const lower = decoded.toLowerCase()
      if (PLATFORM_ALIAS_TO_LABEL[lower]) return PLATFORM_ALIAS_TO_LABEL[lower]
      const prefix = lower.match(/^([a-z]+)(?:[-_]*\d+)?$/)?.[1]
      if (prefix && PLATFORM_ALIAS_TO_LABEL[prefix]) return PLATFORM_ALIAS_TO_LABEL[prefix]
      return ''
    },
    bucketBrowser(v) {
      return this.detectBrowser(v)
    },
    detectPlayinfo(visit = {}) {
      const extra = visit.extra_json || {};
      const s = String(extra.playinfo || extra.player || extra.protocol || visit.referer || '').toLowerCase();
      if (/hls|m3u8/.test(s)) return 'HLS';
      if (/dash|mpd/.test(s)) return 'DASH';
      if (/mp4/.test(s)) return 'MP4';
      if (/flv/.test(s)) return 'FLV';
      return '其他';
    },
    buildFilterOptionsFromVisits(visits = []) {
      const rows = visits.map(v => ({
        region: this.bucketUSRegion((v.country || v.geo_country || ''), (v.region || v.geo_region || '')),
        platform: this.detectPlatform(v),
      }));
      return {
        region: Array.from(new Set(rows.map(x => x.region))),
      };
    },

    initFilters() {
      const end = new Date()
      const start = new Date(end.getTime() - 12 * 60 * 60 * 1000)
      this.filters.range = [this.formatDateTime(start), this.formatDateTime(end)]
      this.isRealtime = true
    },
    onRangeChange(range, meta) {
      this.filters.range = range

      const now = Date.now()
      const start = this.parseTimestamp(range?.[0])
      const end = this.parseTimestamp(range?.[1])

      // 1) 如果组件能告诉你是“快捷选项”，直接判定为实时
      // 不同组件字段名不同，你可以 console.log(meta) 看一下
      const pickedByShortcut =
        meta?.shortcut || meta?.isShortcut || meta?.source === 'shortcut' || meta?.type === 'shortcut'

      if (pickedByShortcut) {
        this.isRealtime = true
        return
      }

      // 2) 如果没有 meta：用 end 是否“贴近现在”判断
      // end 跟 now 很接近（< 60秒）就认为用户想看实时
      const endNearNow = end && Math.abs(now - end) < 12 * 60 * 60 * 1000
      if (endNearNow) {
        this.isRealtime = true
        return
      }

      // 3) 其它情况：认为是固定区间（历史）
      this.isRealtime = false
    },
    async handleQuery() {
      this.$emit('query', { ...this.filters })
      this.closeSSE()
      await this.loadDashboardData()
      this.startSSE()
    },
    async handleReset() {
      this.filters.room = ''
      this.filters.source = ''
      this.initFilters()
      this.$emit('reset')
      this.closeSSE()
      await this.loadDashboardData()
      this.startSSE()
    },
    formatDelta(delta) {
      const val = Number(delta || 0)
      return Math.abs(val).toFixed(1)
    },
    formatPercent(value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '--'
      return `${num.toFixed(1)}%`
    },
    normalizeValue(value, key) {
      if (value === null || value === undefined || value === '') {
        if (key === 'pullSuccessRate') return '0%'
        if (key === 'avgPullSeconds') return '0.0s'
        return '0'
      }
      if (typeof value === 'number') {
        if (key === 'pullSuccessRate') return `${value.toFixed(1)}%`
        if (key === 'avgPullSeconds') return `${value.toFixed(1)}s`
        return value.toLocaleString()
      }
      return value
    },
    setKpis(payload = []) {
      let source
      if (Array.isArray(payload)) {
        source = payload
      } else if (payload && typeof payload === 'object') {
        source = this.kpis.map(k => {
          const patch = payload[k.key] || payload[k.label]
          if (patch === undefined) return k
          if (typeof patch === 'object' && !Array.isArray(patch)) {
            return { ...k, ...patch }
          }
          return { ...k, value: patch }
        })
      } else {
        source = this.kpis
      }

      this.kpis = source.map(item => {
        const key = item.key || item.label || ''
        const label = item.label || item.key || ''
        const value = this.normalizeValue(item.value, key)
        const delta = Number(item.delta ?? 0)
        return { key, label, value, delta }
      })
    },
    setChartData(payload = {}) {
      if (payload.watchTrend) this.chartData.watchTrend = payload.watchTrend
      if (payload.sourceBar) this.chartData.sourceBar = payload.sourceBar
      if (payload.devicePie) this.chartData.devicePie = payload.devicePie
      if (payload.regionBar) this.chartData.regionBar = payload.regionBar
      if (payload.browserPie) this.chartData.browserPie = payload.browserPie
      if (payload.playinfoPie) this.chartData.playinfoPie = payload.playinfoPie

      this.lineOption = this.buildWatchTrendOption(this.chartData.watchTrend)
      this.barOption = this.buildSourceOption(this.chartData.sourceBar)
      this.deviceOption = this.buildDeviceOption(this.chartData.devicePie)
      this.regionOption = this.buildRegionOption(this.chartData.regionBar)
      this.browserOption = this.buildBrowserOption(this.chartData.browserPie)

      if (payload.successRates) {
        this.setSuccessRates(payload.successRates)
      }
    },
    setAbnormalList(list = []) {
      this.abnormalList = Array.isArray(list) ? list.slice(0, 500) : []
    },
    setSuccessRates(rates = {}) {
      this.successRates = {
        playback: rates.playback != null ? Number(rates.playback) : this.successRates.playback,
        audio: rates.audio != null ? Number(rates.audio) : this.successRates.audio,
        danmaku: rates.danmaku != null ? Number(rates.danmaku) : this.successRates.danmaku
      }
    },
    setDanmuTotal(value) {
      const total = Number(value)
      this.danmuTotal = Number.isFinite(total) ? total : 0
      this.kpis = this.kpis.map(item => {
        if (item.key !== 'danmuTotal') return item
        return {
          ...item,
          value: this.normalizeValue(this.danmuTotal, item.key)
        }
      })
    },
    setSelectOptions({ rooms, sources } = {}) {
      if (Array.isArray(rooms) && rooms.length) {
        this.rooms = rooms
      }
      if (Array.isArray(sources) && sources.length) {
        this.sources = sources
      }
    },
    buildWatchTrendOption({ timestamps = [], values = [] } = {}) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 36, right: 12, top: 24, bottom: 30 },
        xAxis: { type: 'category', data: timestamps, boundaryGap: false },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '实时观看',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            areaStyle: { opacity: 0.18 },
            lineStyle: { width: 3 },
            data: values
          }
        ]
      }
    },
    buildRtcJoinQueryParams() {
      const params = new URLSearchParams()

      if (Array.isArray(this.filters.range) && this.filters.range.length === 2) {
        const [start, end] = this.filters.range
        if (start) params.set('from', start)
        if (end) params.set('to', this.isRealtime ? new Date().toISOString() : end)
      }

      if (this.isRealtime) {
        params.set('realtime', '1')
        params.set('bucket_ms', '60000')
      } else {
        params.set('granularity', 'day')
      }

      params.set('group_by', 'none')
      params.set('top', '1')

      if (this.filters.room) params.set('room_id', this.filters.room)
      if (this.filters.source) params.set('source', this.filters.source)

      return params.toString()
    },
    formatRtcJoinBucket(item) {
      const ts = this.parseTimestamp(item?.bucket_start)
      if (ts != null) {
        const d = new Date(ts)
        const pad = n => String(n).padStart(2, '0')
        if (this.isRealtime || item?.bucket_ms < 24 * 60 * 60 * 1000) {
          return `${pad(d.getHours())}:${pad(d.getMinutes())}`
        }
        return `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
      }
      const bucket = String(item?.bucket || '')
      if (!bucket) return ''
      if (this.isRealtime) {
        const d = new Date(bucket)
        if (!Number.isNaN(d.getTime())) {
          const pad = n => String(n).padStart(2, '0')
          return `${pad(d.getHours())}:${pad(d.getMinutes())}`
        }
      }
      return bucket.length >= 10 ? bucket.slice(5, 10) : bucket
    },
    buildRtcJoinOption({ items = [] } = {}) {
      const rows = Array.isArray(items) ? items.slice() : []
      rows.sort((a, b) => {
        const left = this.parseTimestamp(a.bucket_start) || this.parseTimestamp(a.bucket) || 0
        const right = this.parseTimestamp(b.bucket_start) || this.parseTimestamp(b.bucket) || 0
        return left - right
      })

      const labels = rows.map(item => this.formatRtcJoinBucket(item))
      const avgValues = rows.map(item => {
        const value = Number(item.avg_ms)
        return Number.isFinite(value) ? Number(value.toFixed(1)) : null
      })
      const p95Values = rows.map(item => {
        const value = Number(item.p95_ms)
        return Number.isFinite(value) ? Number(value.toFixed(1)) : null
      })
      const sampleCounts = rows.map(item => Number(item.sample_count) || 0)

      return {
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            const list = Array.isArray(params) ? params : []
            const index = list[0]?.dataIndex || 0
            const lines = [`${labels[index] || '-'}`, `样本 ${sampleCounts[index] || 0}`]
            list.forEach(item => {
              const value = item.value == null ? '-' : `${item.value}ms`
              lines.push(`${item.marker}${item.seriesName}: ${value}`)
            })
            return lines.join('<br/>')
          }
        },
        legend: { top: 0, right: 8, textStyle: { color: '#a3b3d1' } },
        grid: { left: 46, right: 14, top: 36, bottom: 30 },
        xAxis: { type: 'category', data: labels, boundaryGap: false },
        yAxis: {
          type: 'value',
          name: 'ms',
          min: 0,
          axisLabel: { formatter: '{value}' }
        },
        series: [
          {
            name: 'Avg',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            lineStyle: { width: 3 },
            areaStyle: { opacity: 0.12 },
            data: avgValues
          },
          {
            name: 'P95',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            lineStyle: { width: 2, type: 'dashed' },
            data: p95Values
          }
        ]
      }
    },
    async fetchRtcJoinSeries() {
      return fetchLiveStatsJsonWithFallback(
        this.apiBase,
        LIVE_STATS_PATHS.rtcJoinSeries,
        LEGACY_LIVE_STATS_PATHS.rtcJoinSeries,
        this.buildRtcJoinQueryParams()
      )
    },
    refreshRtcJoinSeriesIfStale() {
      if (!this.isRealtime) return
      const now = Date.now()
      if (now - this.rtcJoinLastFetchAt < this.rtcJoinMinRefreshMs) return
      this.refreshRtcJoinSeries()
    },
    async refreshRtcJoinSeries() {
      this.rtcJoinLastFetchAt = Date.now()
      try {
        const data = await this.fetchRtcJoinSeries()
        this.rtcJoinOption = this.buildRtcJoinOption(data)
      } catch (error) {
        console.warn('[BigScreen] rtc join series request failed', error)
        this.rtcJoinOption = this.buildRtcJoinOption({ items: [] })
      }
    },
    buildSourceOption({ categories = [], series = [] } = {}) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 12, top: 30, bottom: 40 },
        xAxis: { type: 'category', data: categories, axisTick: { alignWithLabel: true } },
        yAxis: { type: 'value', minInterval: 1 },
        series: [
          {
            name: '流量',
            type: 'bar',
            barWidth: '40%',
            itemStyle: { borderRadius: [4, 4, 0, 0] },
            data: series
          }
        ]
      }
    },
    buildDeviceOption(list = []) {
      return {
        tooltip: { trigger: 'item' },
        legend: { bottom: 0, textStyle: { color: '#a3b3d1' } },
        series: [
          {
            name: '设备占比',
            type: 'pie',
            radius: ['45%', '70%'],
            label: { color: '#e5eaf3' },
            data: list
          }
        ]
      }
    },
    buildRegionOption({ categories = [], series = [] } = {}) {
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: 90, right: 20, top: 30, bottom: 30 },
        xAxis: { type: 'value', minInterval: 1 },
        yAxis: { type: 'category', data: categories, axisLabel: { color: '#e5eaf3' } },
        series: [
          {
            type: 'bar',
            data: series,
            barWidth: '45%',
            itemStyle: { borderRadius: [0, 6, 6, 0] }
          }
        ]
      }
    },
    buildBrowserOption(list = []) {
      return {
        tooltip: { trigger: 'item' },
        legend: { bottom: 0, textStyle: { color: '#a3b3d1' } },
        series: [
          {
            name: '浏览器占比',
            type: 'pie',
            radius: ['45%', '70%'],
            label: { color: '#e5eaf3' },
            data: list
          }
        ]
      }
    },
    BuildPlayInfoOption() {
      const vis = Array.isArray(this.visitsRaw) ? this.visitsRaw : [];
      if (!vis.length) { return { series: [{ type: 'pie', data: [] }] }; }

      const rows = vis.map(v => ({
        ok: v.play_ok === 1,
        region: this.bucketUSRegion((v.country || v.geo_country || ''), (v.region || v.geo_region || '')),
        platform: this.detectPlatform(v),
      }));

      const pass = (r) => {
        const rOk = !this.filterRegion.length || this.filterRegion.includes(r.region);
        const pOk = !this.filterPlatform.length || this.filterPlatform.includes(r.platform);
        return rOk && pOk;
      };
      const filtered = rows.filter(pass);

      const map = new Map();
      for (const r of filtered) {
        const key = r[this.successDim];
        const rec = map.get(key) || { ok: 0, total: 0 };
        rec.total += 1;
        rec.ok += r.ok ? 1 : 0;
        map.set(key, rec);
      }
      const data = Array.from(map.entries())
        .map(([name, v]) => ({ name, value: v.ok, _ok: v.ok, _total: v.total, _rate: v.total ? (v.ok / v.total * 100) : 0 }))
        .filter(d => d._total > 0)
        .sort((a, b) => b.value - a.value);
      return {
        tooltip: { trigger: 'item', formatter: p => `${p.name}<br/>成功 ${p.data._ok}/${p.data._total}（${p.data._rate.toFixed(1)}%）` },
        legend: { orient: 'vertical', left: 20, top: 30, textStyle: { color: '#cfd7ff' }, type: 'scroll' },
        series: [{ type: 'pie', radius: ['35%', '70%'], label: { formatter: '{b}\n{d}%' }, data }]
      };
    },
    async loadRooms() {
      try {
        let start = new Date(Date.now() - 90 *24 *60 *60*1000).toLocaleString().replaceAll('/','-')
        const res = await liveroomsList(this.wokfoy_appid,100, 1,start)
        const list = res?.data?.data || res?.data || []
        if (!Array.isArray(list) || list.length === 0) return
        const routeRoom = String(this.$route.query.room || '').trim()
        const options = list.map(item => ({
          label: item.stream_name,
          value: item.stream_name,
          id: item.id,
          status: item.status
        }))
        this.roomIdByStreamName = options.reduce((map, item) => {
          const name = String(item.value || '').trim()
          if (name && item.id != null && item.id !== '') {
            map[name] = String(item.id)
          }
          return map
        }, {})
        this.setSelectOptions({ rooms: [{ label: '全部房间', value: '' }, ...options] })
        const active = list.find(item => item.stream_name === routeRoom) || list.find(item => item.status === 1) || list[0]
        if (active) {
          if (routeRoom) {
            this.filters.room = routeRoom
          } else if (!this.filters.room) {
            this.filters.room = active.stream_name
          }
        }
      } catch (err) {
        console.error('[BigScreen] loadRooms failed', err)
      }
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString()
    },
    getDanmuStreamId(roomValue) {
      const key = String(roomValue || '').trim()
      if (!key) return ''
      const mapped = this.roomIdByStreamName[key]
      if (mapped) return mapped
      const option = this.rooms.find(item => {
        return String(item.value || '').trim() === key || String(item.id || '').trim() === key
      })
      return String(option?.id || key).trim()
    },
    getDanmuTimeRangeParams() {
      if (!Array.isArray(this.filters.range) || this.filters.range.length !== 2) return {}
      const [start, end] = this.filters.range
      return {
        ...(start ? { start_time: start } : {}),
        ...(end ? { end_time: this.isRealtime ? this.formatDateTime(new Date()) : end } : {})
      }
    },
    resolveDanmuStreamIds(visits = []) {
      const ids = new Set()
      const addRoom = room => {
        const id = this.getDanmuStreamId(room)
        if (id) ids.add(id)
      }

      if (this.filters.room) {
        addRoom(this.filters.room)
        return Array.from(ids)
      }

      ;(Array.isArray(visits) ? visits : []).forEach(visit => addRoom(visit?.room_id))

      if (!ids.size && !this.filters.source) {
        this.rooms.forEach(room => {
          if (room?.value) ids.add(String(room.id || room.value))
        })
      }

      return Array.from(ids)
    },
    isUserDanmuMessage(item = {}) {
      const nickname = String(item.nickname || '').trim()
      const mcName = String(item.mc_user_name || '').trim()
      return !(nickname && mcName && nickname === mcName)
    },
    getDanmuHistoryRows(payload) {
      if (Array.isArray(payload)) return payload
      if (Array.isArray(payload?.data)) return payload.data
      if (Array.isArray(payload?.list)) return payload.list
      if (Array.isArray(payload?.items)) return payload.items
      return []
    },
    getDanmuHistoryTotal(payload) {
      const candidates = [
        payload?.total,
        payload?.count,
        payload?.pagination?.total,
        payload?.meta?.total
      ]
      const total = candidates.map(Number).find(value => Number.isFinite(value) && value >= 0)
      return total == null ? null : total
    },
    async fetchDanmuCountForStream(streamId) {
      if (!streamId) return 0
      const perPage = 500
      const maxPages = 200
      let page = 1
      let count = 0
      const timeParams = this.getDanmuTimeRangeParams()
      let includeTimeParams = Object.keys(timeParams).length > 0

      while (page <= maxPages) {
        const params = {
          stream_id: streamId,
          order: 'asc',
          event_type: 'LIVE_ROOM_STREAM_EVENT_TYPE_USER_SEND_MESSAGE',
          per_page: perPage,
          page,
          ...(includeTimeParams ? timeParams : {})
        }
        let data
        try {
          ;({ data } = await getDanmu(params))
        } catch (err) {
          if (includeTimeParams) {
            includeTimeParams = false
            page = 1
            count = 0
            continue
          }
          console.warn('[BigScreen] danmu history request failed', streamId, err)
          return count
        }
        const rows = this.getDanmuHistoryRows(data)
        const total = this.getDanmuHistoryTotal(data)

        count += rows.filter(item => this.isUserDanmuMessage(item)).length

        if (rows.length < perPage) break
        if (total != null && page * perPage >= total) break
        page += 1
      }

      return count
    },
    async fetchDanmuTotalForCurrentFilter(visits = []) {
      const requestSeq = ++this.danmuTotalRequestSeq
      const streamIds = this.resolveDanmuStreamIds(visits)
      if (!streamIds.length) return 0

      const batchSize = 5
      let total = 0
      for (let i = 0; i < streamIds.length; i += batchSize) {
        const batch = streamIds.slice(i, i + batchSize)
        const counts = await Promise.all(batch.map(id => this.fetchDanmuCountForStream(id)))
        if (requestSeq !== this.danmuTotalRequestSeq) return this.danmuTotal
        total += counts.reduce((sum, value) => sum + value, 0)
      }
      return total
    },
    formatDateTime(date) {
      const pad = n => String(n).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    formatTime(value) {
      const ts = this.parseTimestamp(value)
      if (ts == null) return '-'
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    buildQueryParams({ limit = 500, offset = 0 } = {}) {
      // const params = new URLSearchParams()
      // params.set('limit', limit)
      // params.set('offset', offset)
      // if (Array.isArray(this.filters.range) && this.filters.range.length === 2) {
      //   const [start, end] = this.filters.range
      //   if (start) params.set('from', start)
      //   if (end) params.set('to', end)
      // }
      // if (this.filters.room) params.set('room_id', this.filters.room)
      // if (this.filters.source) params.set('source', this.filters.source)
      // return params.toString()
      const params = new URLSearchParams()

      if (Array.isArray(this.filters.range) && this.filters.range.length === 2) {
        const [start, end] = this.filters.range
        if (start) params.set('from', start)

        // const endTs = this.parseTimestamp(end)
        // const now = Date.now()
        const endTs = this.isRealtime ? new Date().toISOString() : this.filters.range[1]
        params.set('to', endTs)
      }

      if (this.filters.room) params.set('room_id', this.filters.room)
      if (this.filters.source) params.set('source', this.filters.source)

      // extra
      if (limit != null) params.set('limit', String(limit))
      if (offset != null) params.set('offset', String(offset))

      return params.toString()
    },

    async fetchVisits() {
      const base = this.apiBase
      // if (!base) throw new Error('统计接口地址未配置')
      const limit = 500
      const maxPages = 10
      const all = []
      let offset = 0
      for (let page = 0; page < maxPages; page++) {
        const query = this.buildQueryParams({ limit, offset })
        const data = await fetchLiveStatsJsonWithFallback(
          base,
          LIVE_STATS_PATHS.visits,
          LEGACY_LIVE_STATS_PATHS.visits,
          query
        )
        const items = Array.isArray(data.items) ? data.items.map(item => this.normalizeVisit(item)) : []
        all.push(...items)
        if (items.length < limit) break
        offset += limit
      }
      return all
    },
    // ===== 大屏快照（HTTP） =====
    // 优先调用新版 dashboard-snapshot，后端最多返回 5000 条。
    // 如果快照请求失败，则回退到访问明细分页拉取。
    async fetchDashboardSnapshot() {
      const base = this.apiBase
      // if (!base) throw new Error('统计接口地址未配置')

      const query = this.buildQueryParams({ limit: 5000, offset: 0 })
      try {
        const data = await fetchLiveStatsJsonWithFallback(
          base,
          LIVE_STATS_PATHS.dashboardSnapshot,
          LEGACY_LIVE_STATS_PATHS.dashboardSnapshot,
          query
        )
        const items = Array.isArray(data.items) ? data.items : []
        const visits = items.map(item => this.normalizeVisit(item))
        this.rebuildVisitIndex(visits)
        return visits
      } catch (e) {
        console.warn('[BigScreen] dashboard snapshot request failed, fallback to visits paging', e)
      }

      const visits = await this.fetchVisits()
      this.rebuildVisitIndex(visits)
      return visits
    },

    // 为增量合并建立 sid -> index 映射
    rebuildVisitIndex(visits = []) {
      try {
        this.visitIndex = new Map()
        visits.forEach((v, i) => {
          if (v && v.sid) this.visitIndex.set(String(v.sid), i)
        })
      } catch (e) {
        this.visitIndex = null
      }
    },

    // ===== SSE（实时增量） =====
    closeSSE() {
      if (this.sse) {
        try { this.sse.close() } catch (e) { }
        this.sse = null
      }
      if (this.recomputeTimer) {
        clearTimeout(this.recomputeTimer)
        this.recomputeTimer = null
      }
    },

    startSSE() {
      const base = (this.apiBase || '').replace(/\/$/, '')
      if (!base) return
      if (this.sse) return

      const url = buildLiveStatsUrl(base, LIVE_STATS_PATHS.stream)
      const es = new EventSource(url)
      this.sse = es

      es.addEventListener('hello', () => {
        // 可选：console.log('[BigScreen] SSE connected')
      })

      es.addEventListener('visit_delta', (ev) => {
        let delta = null
        try { delta = JSON.parse(ev.data || '{}') } catch (e) { delta = null }
        if (!delta || !delta.sid) return
        this.applyVisitDelta(delta)
        this.scheduleRecompute()
      })

      es.onerror = () => {
        // EventSource 会自动重连，这里不主动 close
        // 如需提示可以打开：
        // this.error = '实时连接中断，正在自动重连...'
      }
    },

    inCurrentRange(ts) {
      if (!ts) return true
      if (!Array.isArray(this.filters.range) || this.filters.range.length !== 2) return true

      const from = this.parseTimestamp(this.filters.range[0])
      const end = this.isRealtime ? Date.now() : this.parseTimestamp(this.filters.range[1])

      if (from && ts < from) return false
      if (end && ts > end) return false
      return true
    },
    buildExtraParsedFromDeltaExtra(extra) {
      const e = extra && typeof extra === 'object' ? extra : {}
      const safeArr = (v) => Array.isArray(v) ? v : (typeof v === 'string' ? (() => {
        try { const a = JSON.parse(v); return Array.isArray(a) ? a : [] } catch { return [] }
      })() : [])

      const safeObj = (v) => (v && typeof v === 'object' && !Array.isArray(v)) ? v : (typeof v === 'string' ? (() => {
        try { const o = JSON.parse(v); return (o && typeof o === 'object' && !Array.isArray(o)) ? o : {} } catch { return {} }
      })() : {})

      return {
        extra: e,
        file_logs: safeArr(e.file_logs),
        api_logs: safeArr(e.api_logs),
        webrtc_info: safeObj(e.webrtc_info),
        play_metrics: safeObj(e.play_metrics),
      }
    },
    applyVisitDelta(delta) {
      if (!delta || !delta.sid) return

      // delta.ts / delta.enter_ts / delta.exit_ts 任选其一
      const ts = delta.ts || delta.enter_ts || delta.exit_ts
      if (ts && !this.inCurrentRange(ts)) return

      const idx = this.visitsRaw.findIndex(v => v.sid === delta.sid)

      // 把 SSE 的 extra 补成 extra_parsed，保持和访问明细返回结构一致。
      const extra = (delta.extra && typeof delta.extra === 'object') ? delta.extra : {}
      const extra_parsed = this.buildExtraParsedFromDeltaExtra(extra)

      if (idx === -1) {
        const row = {
          sid: delta.sid,
          cid: delta.cid || '',
          enter_ts: delta.enter_ts || delta.ts || null,
          exit_ts: delta.exit_ts || null,
          duration_ms: delta.duration_ms || 0,
          ip: delta.ip || '',
          country: delta.country || '',
          region: delta.region || '',
          city: delta.city || '',
          ua: delta.ua || '',
          referer: delta.referer || '',
          room_id: delta.room_id || '',
          play_ok: delta.play_ok ?? null,

          // 关键：两套字段都补齐
          extra_json: extra,
          extra_parsed,
        }

        // Vue2：用 unshift 是响应式的
        this.visitsRaw.unshift(row)
        return
      }

      const prev = this.visitsRaw[idx] || {}

      const merged = {
        ...prev,
        ...delta,
        // 关键：保持两套字段一直存在
        extra_json: { ...(prev.extra_json || {}), ...extra },
        extra_parsed: prev.extra_parsed ? {
          ...prev.extra_parsed,
          ...extra_parsed,
          extra: { ...(prev.extra_parsed.extra || {}), ...extra }
        } : extra_parsed,
      }

      // Vue2：更新数组某个 index 必须用 this.$set，否则可能不触发视图更新
      this.$set(this.visitsRaw, idx, merged)
    },

    scheduleRecompute() {
      if (this.recomputeTimer) clearTimeout(this.recomputeTimer)
      this.recomputeTimer = setTimeout(() => {
        try {
          const visits = Array.isArray(this.visitsRaw) ? this.visitsRaw : []
          this.filterOptions = this.buildFilterOptionsFromVisits(visits)
          const summary = this.buildSummary(visits)
          this.watchMetrics = summary.watchMetrics || { watch3s: 0, watch15s: 0, watch60s: 0 }
          this.setKpis(summary.kpis)
          this.setChartData(summary.charts)
          this.setAbnormalList(summary.abnormalList)
          this.setSuccessRates(summary.successRates)
          this.refreshRtcJoinSeriesIfStale()
        } catch (e) {
          console.warn('[BigScreen] recompute failed', e)
        }
      }, this.recomputeDelayMs)
    },
    normalizeVisit(raw = {}) {
      const extra = raw.extra_json
      let parsed = {}
      if (typeof extra === 'string') {
        try {
          parsed = JSON.parse(extra) || {}
        } catch (err) {
          parsed = {}
        }
      } else if (extra && typeof extra === 'object') {
        parsed = extra
      }
      return {
        ...raw,
        extra_json: parsed,
        play_ok: this.resolveStatus(raw.play_ok),
        duration_ms: Number(raw.duration_ms) || 0,
        enter_ts: this.parseTimestamp(raw.enter_ts)
      }
    },
    resolveStatus(value) {
      if (value === null || value === undefined) return null
      if (typeof value === 'number') {
        if (value === 1) return 1
        if (value === 0) return 0
        return null
      }
      if (typeof value === 'boolean') return value ? 1 : 0
      if (typeof value === 'string') {
        const lower = value.trim().toLowerCase()
        if (['1', 'true', 'ok', 'success', 'yes'].includes(lower)) return 1
        if (['0', 'false', 'fail', 'failed', 'no', 'error'].includes(lower)) return 0
      }
      return null
    },
    parseTimestamp(value) {
      if (value === null || value === undefined) return null
      if (typeof value === 'number') {
        return Number.isNaN(value) ? null : value
      }
      if (value instanceof Date) return value.getTime()
      if (typeof value === 'string') {
        const num = Number(value)
        if (!Number.isNaN(num) && num > 1e9) return num
        const d = new Date(value)
        const ts = d.getTime()
        return Number.isNaN(ts) ? null : ts
      }
      return null
    },
    resolveBoolean(value) {
      if (value === null || value === undefined) return null
      if (typeof value === 'boolean') return value
      if (typeof value === 'number') {
        if (value === 1) return true
        if (value === 0) return false
        return null
      }
      if (typeof value === 'string') {
        const lower = value.trim().toLowerCase()
        if (['1', 'true', 'yes', 'y', 'ok', 'success'].includes(lower)) return true
        if (['0', 'false', 'no', 'n', 'fail', 'failed', 'error'].includes(lower)) return false
      }
      return null
    },
    detectSource(visit) {
      const rawReferer = visit.referer || visit.referrer || ''
      const utm = visit.utm_source || visit.extra_json?.utm_source || ''
      const combined = `${rawReferer} ${utm}`.toLowerCase()
      const mapping = [
        { label: 'tiktok', match: ['utm_source=tk', 'utm_source=tiktok', 'tiktok', 'douyin'] },
        { label: 'Facebook', match: ['utm_source=fb', 'utm_source=facebook', 'facebook'] },
        { label: 'YouTube', match: ['utm_source=yt', 'utm_source=youtube', 'youtube'] },
        { label: 'Pinterest', match: ['utm_source=pin', 'utm_source=pinterest', 'pinterest'] },
        { label: 'Google', match: ['utm_source=google', 'google'] },
        { label: 'X', match: ['utm_source=X', 'X', 'twitter'] },
        { label: 'ins', match: ['utm_source=instagram', 'ins', 'instagram'] },
        { label: 'snap', match: ['utm_source=snap', 'snap'] },
        { label: '广告', match: ['utm_source=ads', 'utm_medium=cpc', 'adset', 'adgroup'] }
      ]
      for (const item of mapping) {
        if (item.match.some(key => combined.includes(key))) return item.label
      }
      // if (rawReferer) {
      //   try {
      //     const url = new URL(rawReferer)
      //     return url.hostname.replace(/^www\./, '')
      //   } catch (err) {
      //     // ignore
      //   }
      // }
      return '其他'
    },
    detectDevice(visit) {
      const ua = (visit.ua || visit.user_agent || '').toLowerCase()
      if (!ua) return '未知'
      if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ios')) return 'iOS'
      if (ua.includes('android')) return 'Android'
      if (ua.includes('windows')) return 'Windows'
      if (ua.includes('mac os') || ua.includes('macintosh')) return 'Mac'
      if (ua.includes('linux')) return 'Linux'
      if (ua.includes('micromessenger')) return '微信内置'
      if (ua.includes('huawei')) return '华为'
      return '其他'
    },
    detectRegionKey(visit) {
      const country = (visit.country || visit.geo_country || '').toUpperCase()
      const region = visit.region || visit.geo_region || visit.city || ''
      const parts = [country, region].filter(Boolean)
      return parts.length ? parts.join('-') : '未知'
    },
    formatRegionLabel(visit) {
      const country = visit.country || visit.geo_country || ''
      const region = visit.region || visit.geo_region || visit.city || ''
      const parts = [country, region].filter(Boolean)
      return parts.length ? parts.join(' / ') : '-'
    },
    detectBrowser(visit) {
      const ua = (visit.ua || visit.user_agent || '').toLowerCase()
      if (!ua) return '未知'
      if (ua.includes('micromessenger')) return '微信内置'
      if (ua.includes('qqbrowser')) return 'QQ浏览器'
      if (ua.includes('ucbrowser')) return 'UC浏览器'
      if (ua.includes('edg')) return 'Edge'
      if (ua.includes('opr') || ua.includes('opera')) return 'Opera'
      if (ua.includes('firefox')) return 'Firefox'
      if (ua.includes('chrome') && !ua.includes('edg') && !ua.includes('opr')) return 'Chrome'
      if (ua.includes('safari') && ua.includes('WKWebview')) return 'TK内置'
      if (ua.includes('safari') && !ua.includes('chrome')) return 'Safari'
      return '其他'
    },
    buildMinuteBucket(ts) {
      const value = this.parseTimestamp(ts)
      if (value == null) return null
      const d = new Date(value)
      const pad = n => String(n).padStart(2, '0')
      return {
        label: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
        order: Math.floor(value / 60000)
      }
    },
    mapTrendSeries(map) {
      const entries = Array.from(map.entries()).sort((a, b) => a[1].order - b[1].order)
      return {
        timestamps: entries.map(([label]) => label),
        values: entries.map(([, data]) => data.count)
      }
    },
    mapBarSeries(map, limit = 10) {
      const entries = Array.from(map.entries()).filter(([label]) => !!label)
      entries.sort((a, b) => b[1] - a[1])
      if (limit && entries.length > limit) {
        const head = entries.slice(0, limit - 1)
        const tail = entries.slice(limit - 1)
        const otherValue = tail.reduce((sum, [, val]) => sum + val, 0)
        if (otherValue > 0) {
          head.push(['其他', otherValue])
        }
        return {
          categories: head.map(([label]) => label),
          series: head.map(([, val]) => val)
        }
      }
      return {
        categories: entries.map(([label]) => label),
        series: entries.map(([, val]) => val)
      }
    },
    mapPieSeries(map, limit = 6) {
      const entries = Array.from(map.entries()).map(([label, value]) => [label || '未知', value])
      entries.sort((a, b) => b[1] - a[1])
      if (!limit || entries.length <= limit) {
        return entries.map(([name, value]) => ({ name, value }))
      }
      const head = entries.slice(0, limit - 1)
      const restValue = entries.slice(limit - 1).reduce((sum, [, val]) => sum + val, 0)
      const result = head.map(([name, value]) => ({ name, value }))
      if (restValue > 0) {
        result.push({ name: '其他', value: restValue })
      }
      return result
    },
    buildSummary(visits) {
      const uvSet = new Set()
      let sumDuration = 0
      let firstFrameSum = 0
      let firstFrameCount = 0
      let successCount = 0
      let successKnown = 0
      let audioOk = 0
      let danmakuOk = 0
      let clickShoppingCart = 0
      let clickContact = 0

      // 观看分层（按单次访问停留时长 duration_ms 统计）
      let watch3s = 0
      let watch15s = 0
      let watch60s = 0

      const watchMap = new Map()
      const sourceMap = new Map()
      const deviceMap = new Map()
      const regionMap = new Map()
      const browserMap = new Map()
      const abnormal = []

      visits.forEach(visit => {
        const uvKey = visit.cid || visit.sid || visit.user_id || (visit.ip ? `${visit.ip}-${visit.ua || ''}` : null)
        if (uvKey) uvSet.add(uvKey)

        if (visit.play_ok === 1) {
          successCount += 1
          successKnown += 1
        } else {
          successKnown += 1
        }
        const extra = visit.extra_parsed?.extra || {}
        if (extra.click_shoppingcart) clickShoppingCart += 1
        if (extra.open_contact) clickContact += 1

        const audioFlag = [
          extra.audio_receive_success,
          extra.first_audio_frame,
          extra.subscribe_audio_success
        ].some(value => this.resolveBoolean(value) === true)
        if (audioFlag) audioOk += 1

        const danmuFlag = this.resolveBoolean(extra.danmu)
        if (danmuFlag === true) danmakuOk += 1

        const duration = Number(visit.duration_ms) || 0
        sumDuration += duration

        if (duration >= 3000) watch3s += 1
        if (duration >= 15000) watch15s += 1
        if (duration >= 60000) watch60s += 1

        const firstFrame = Number(visit.t_first ?? visit.extra_json?.t_first)
        if (!Number.isNaN(firstFrame) && firstFrame > 0) {
          firstFrameSum += firstFrame
          firstFrameCount += 1
        }

        const bucket = this.buildMinuteBucket(visit.enter_ts)
        if (bucket) {
          const entry = watchMap.get(bucket.label)
          if (entry) {
            entry.count += 1
          } else {
            watchMap.set(bucket.label, { count: 1, order: bucket.order })
          }
        }

        const source = this.detectSource(visit)
        sourceMap.set(source, (sourceMap.get(source) || 0) + 1)

        const device = this.detectDevice(visit)
        deviceMap.set(device, (deviceMap.get(device) || 0) + 1)

        const regionKey = this.detectRegionKey(visit)
        regionMap.set(regionKey, (regionMap.get(regionKey) || 0) + 1)

        const browser = this.detectBrowser(visit)
        browserMap.set(browser, (browserMap.get(browser) || 0) + 1)


        if (duration <= 3000 || visit.play_ok !== 1 || danmuFlag === false) {
          const reasonParts = []
          if (visit.play_ok === 0) reasonParts.push('播放失败')
          else if (visit.play_ok === null) reasonParts.push('播放未知')
          if (duration > 0 && duration <= 3000) reasonParts.push(`停留${(duration / 1000).toFixed(1)}s`)
          if (danmuFlag === false) reasonParts.push('弹幕未加载')
          const reason = reasonParts.join(' / ')
          if (reason) {
            abnormal.push({
              timestamp: this.formatTime(visit.enter_ts),
              ip: visit.ip || '-',
              region: this.formatRegionLabel(visit),
              device,
              reason
            })
          }
        }
      })

      const pv = visits.length
      const uv = uvSet.size
      const playbackRate = successKnown ? (successCount / successKnown) * 100 : 0
      const audioRate = pv ? (audioOk / pv) * 100 : 0
      const danmakuRate = pv ? (danmakuOk / pv) * 100 : 0
      let avgPullSeconds = 0
      if (firstFrameCount > 0) {
        avgPullSeconds = firstFrameSum / firstFrameCount / 1000
      } else if (pv > 0) {
        avgPullSeconds = sumDuration / pv / 1000
      }

      const watchTrend = this.mapTrendSeries(watchMap)
      const sourceBar = this.mapBarSeries(sourceMap, 8)
      const devicePie = this.mapPieSeries(deviceMap, 6)
      const regionBar = this.mapBarSeries(regionMap, 8)
      const browserPie = this.mapPieSeries(browserMap, 6)
      const abnormalList = abnormal.slice(0, 80)

      return {
        watchMetrics: { watch3s, watch15s, watch60s },
        kpis: [
          { key: 'uv', label: 'UV', value: uv, delta: 0 },
          { key: 'pv', label: 'PV', value: pv, delta: 0 },
          { key: 'pullSuccessRate', label: '拉流成功率', value: playbackRate, delta: 0 },
          { key: 'avgPullSeconds', label: '平均播放时长(s)', value: avgPullSeconds, delta: 0 },
          { key: 'danmuTotal', label: '弹幕总数', value: 0, delta: 0 },
          { key: 'shoppingCartTotal', label: '购物车点击', value: clickShoppingCart, delta: 0 },
          { key: 'contactTotal', label: '联系客服点击', value: clickContact, delta: 0 },
          { key: 'qualityRates', label: '加载成功率', value: null, delta: 0 }
        ],
        charts: {
          watchTrend,
          sourceBar,
          devicePie,
          regionBar,
          browserPie
        },
        successRates: { playback: playbackRate, audio: audioRate, danmaku: danmakuRate },
        abnormalList
      }
    },
    async loadDashboardData() {
      this.loading = true
      this.error = ''
      try {
        const [snapshotVisits] = await Promise.all([
          this.fetchDashboardSnapshot(),
          this.refreshRtcJoinSeries()
        ])
        let visits = snapshotVisits
        visits = visits.filter(f => f.duration_ms > 2000 && f.room_id)
        const historyDanmuTotal = await this.fetchDanmuTotalForCurrentFilter(visits)
        if (!visits.length) {
          this.watchMetrics = { watch3s: 0, watch15s: 0, watch60s: 0 }
          this.setKpis([
            { key: 'uv', label: 'UV', value: 0, delta: 0 },
            { key: 'pv', label: 'PV', value: 0, delta: 0 },
            { key: 'pullSuccessRate', label: '拉流成功率', value: 0, delta: 0 },
            { key: 'avgPullSeconds', label: '平均拉流秒数', value: 0, delta: 0 },
            { key: 'danmuTotal', label: '弹幕总数', value: historyDanmuTotal, delta: 0 },
            { key: 'shoppingCartTotal', label: '购物车点击', value: 0, delta: 0 },
            { key: 'contactTotal', label: '联系客服点击', value: 0, delta: 0 },
            { key: 'qualityRates', label: '加载成功率', value: null, delta: 0 }
          ])
          this.setDanmuTotal(historyDanmuTotal)
          this.setChartData({
            watchTrend: { timestamps: [], values: [] },
            sourceBar: { categories: [], series: [] },
            devicePie: [],
            regionBar: { categories: [], series: [] },
            browserPie: [],
            playinfoPie: []
          })
          this.setAbnormalList([])
          this.setSuccessRates({ playback: 0, audio: 0, danmaku: 0 })
          return
        }
        this.visitsRaw = Array.isArray(visits) ? visits.slice() : [];
        this.filterOptions = this.buildFilterOptionsFromVisits(visits);
        const summary = this.buildSummary(visits)
        this.watchMetrics = summary.watchMetrics || { watch3s: 0, watch15s: 0, watch60s: 0 }
        this.setKpis(summary.kpis)
        this.setDanmuTotal(historyDanmuTotal)
        this.setChartData(summary.charts)
        this.setAbnormalList(summary.abnormalList)
        this.setSuccessRates(summary.successRates)
      } catch (err) {
        console.error('[BigScreen] loadDashboardData error', err)
        this.error = err.message || '数据加载失败'
        // this.bootstrapMockData()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
body {
  background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%);
}

.bigscreen {
  padding: 12px;
  background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%);
  min-height: 100vh;
  color: #e5eaf3;
  box-sizing: border-box;
}

.bigscreen-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  margin-bottom: 12px;
  padding: 0 16px;
  border: 1px solid rgba(121, 162, 255, 0.28);
  border-radius: 12px;
  background: rgba(8, 17, 38, 0.9);
  color: #dce8ff;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.bigscreen-back:hover {
  border-color: rgba(121, 162, 255, 0.52);
  background: rgba(16, 30, 60, 0.96);
}

.toolbar {
  margin-bottom: 12px;
  background: rgba(10, 18, 32, 0.9);
  border: 1px solid #14203a;
}

.toolbar ::v-deep .el-form-item__label {
  color: #9fb4d3;
}

.error-alert {
  margin-bottom: 12px;
  background: rgba(255, 153, 0, 0.12);
  border: 1px solid rgba(255, 153, 0, 0.32);
  color: #ffcf8f;
}

.full {
  background: radial-gradient(circle at top left, rgba(29, 78, 216, 0.16), transparent 40%),
    linear-gradient(140deg, #050b1a, #081126 55%, #040713 100%);
  height: calc(100vh - 24px);
}

.left {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.left {
  overflow-y: scroll;
}

::-webkit-scrollbar {
  display: none;
}

.panel {
  background: rgba(10, 18, 32, 0.92);
  border: 1px solid #14203a;
  color: #e5eaf3;
  margin-bottom: 12px;

}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.panel-substats {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #98a9c9;
}

.panel-substats strong {
  color: #53c3ff;
  margin-left: 6px;
}

.kpi-row {
  margin-bottom: 12px;
}

.kpi-card {
  position: relative;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(160deg, rgba(14, 53, 118, 0.5), rgba(9, 19, 42, 0.8));
  border: 1px solid rgba(64, 158, 255, 0.18);
}

.kpi-label {
  font-size: 13px;
  opacity: 0.78;
}

.kpi-value {
  font-size: 26px;
  font-weight: 700;
  margin-top: 6px;
}

.kpi-dual-metrics {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
}

.kpi-dual-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.kpi-dual-row span {
  color: #cfd7ff;
  font-size: 13px;
  opacity: 0.82;
}

.kpi-dual-row strong {
  color: #ffffff;
  font-size: 22px;
  line-height: 1;
}

.kpi-delta {
  position: absolute;
  top: 10px;
  right: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.08);
}

.kpi-delta.up {
  color: #67c23a;
}

.kpi-delta.down {
  color: #f56c6c;
}

.chart-card,
.table-card {
  flex: none;
}

.chart-grid {
  margin-bottom: 12px;
}

.watch-metrics-row {
  margin-bottom: 12px;
}

.watch-card {
  background: linear-gradient(160deg, rgba(14, 53, 118, 0.35), rgba(9, 19, 42, 0.88));
  border: 1px solid rgba(64, 158, 255, 0.18);
}

.watch-items {
  padding: 6px 4px;
}

.watch-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 6px;
  border-bottom: 1px dashed rgba(159, 180, 211, 0.18);
}

.watch-item:last-child {
  border-bottom: none;
}

.watch-label {
  color: #cfd7ff;
  opacity: 0.85;
  font-size: 13px;
}

.watch-value {
  font-size: 18px;
  font-weight: 700;
  color: #e5eaf3;
}

.el-table {
  background: transparent;
}

.el-table::before {
  background: transparent;
}

.el-table th,
.el-table td {
  background: transparent;
  color: #e5eaf3;
}

.el-table th {
  color: #9fb4d3;
}

.my-loading .el-loading-spinner {
  top: 0;
  /* 距离容器顶部 */
  margin-top: 0 !important;
  /* 干掉默认的 -21px 之类的居中偏移 */
}
</style>
